{
  "consent": {
    "title": "Connect an app",
    "intro": "{{name}} asks for access to CloudServer on your behalf. Choose what the app may do — it never gets more than your own rights.",
    "secondFactor": "Allowing is confirmed with your second factor",
    "app": "App",
    "returnsTo": "The answer goes to",
    "resource": "Access to",
    "onlyIfYou": "Allow only if you started connecting in this app just now. If not, choose “Decline”.",
    "warnings": {
      "localRedirect": "The answer goes to a program on this computer ({{host}}). Any program can claim such an address: allow only if you are connecting an app on this computer yourself.",
      "selfNamed": "The app gave this name itself; we have not verified it. Check the address the answer goes to."
    },
    "policy": "What the app may do",
    "policyLead": "Like an API key: a template, a policy of the organisation or your own rules. Better not allow deleting and rebuilding without a need.",
    "allowSecretLead": "The app may add SSH keys and enable rescue mode. Root passwords and the console are never handed out over MCP.",
    "projects": "In which projects",
    "allProjectsLead": "Every project you can reach, future ones too.",
    "someProjectsLead": "Only the projects you tick.",
    "gets": "What the app gets",
    "getsPolicy": "The rights of “{{policy}}” in: {{projects}}.",
    "getsNeverMore": "Never more than your own rights: if yours are narrowed, so are the app's.",
    "getsSecret": "Secret actions allowed (SSH keys, rescue mode), but no passwords and no console.",
    "getsNoSecret": "No secret actions: SSH keys, passwords and the console stay out of reach.",
    "getsTokens": "Access tokens live {{minutes}} minutes and refresh by themselves; access lasts until {{until}} unless you disconnect the app sooner.",
    "getsRevoke": "You can disconnect the app at any time: “API and integrations” → “Connected apps”.",
    "allow": "Allow",
    "deny": "Decline",
    "leaving": "Taking you back to {{host}}…",
    "toApps": "To connected apps",
    "errors": {
      "invalid_client": "The app is unknown or its description did not pass our checks. Start connecting in the app again.",
      "invalid_redirect_uri": "The app asks for the answer at an address it did not register. We will not send it there.",
      "invalid_request": "The connection request is incomplete or invalid. Start connecting in the app again."
    }
  },
  "kind": {
    "document": "Verified at {{host}}",
    "dynamic": "Name given by the app itself"
  },
  "apps": {
    "empty": "No connected apps",
    "emptyLead": "When you connect CloudServer in claude.ai, a Claude app or ChatGPT, the app appears here: what it may do, when it worked, and a button to disconnect it.",
    "name": "App",
    "returnsTo": "answers at {{host}}",
    "user": "Whose",
    "open": "Open",
    "activityEmptyLead": "The app's MCP calls and changes of the connection itself appear here."
  },
  "app": {
    "intro": "Connected by signing in to CloudServer; acts on behalf of {{user}}.",
    "client": "OAuth client",
    "redirect": "Answer address",
    "connected": "Connected",
    "until": "Access until",
    "revokedAt": "Disconnected",
    "whatLead": "The chosen policy intersected with the rights of the person the app acts for."
  },
  "revoke": {
    "title": "Disconnect “{{name}}”?",
    "stops": "The app loses access at once: its tokens stop working.",
    "again": "To use it again, the app has to ask for permission anew.",
    "action": "Disconnect",
    "done": "“{{name}}” disconnected"
  },
  "activity": {
    "oauth_app_created": "App connected",
    "oauth_app_revoked": "App disconnected",
    "oauth_app_refused": "App's call refused",
    "oauth_app_denied": "Connection declined",
    "oauth_app_refresh_reused": "Token reused — app disconnected"
  }
}
